import { render, staticRenderFns } from "./CmgNearbyRestaurantAlert.vue?vue&type=template&id=610db170&scoped=true&lang=pug"
import script from "./cmg-nearby-restaurant-alert.ts?vue&type=script&lang=ts&external"
export * from "./cmg-nearby-restaurant-alert.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgNearbyRestaurantAlert.vue?vue&type=style&index=0&id=610db170&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610db170",
  null
  
)

export default component.exports